// extracted by mini-css-extract-plugin
export default {"component":"styles_component__KL9uK","error":"styles_error__dCI5T","success":"styles_success__MMait","warning":"styles_warning__YUxZf"};